<template>
  <loading-page v-if="fetchtingExternalAccount" />
  <parent v-else>
    <external-account-from
      :external-account="externalAccount"
      @save="updateAccount"
    />
  </parent>
</template>

<script>
import redirectError from '@/services/redirectError'
import ExternalAccountFrom from './Form.vue'

export default {
  name: 'EditExternalAccount',
  components: { ExternalAccountFrom },
  computed: {
    externalAccount() {
      return this.$store.state.externalAccount.externalAccount
    },
    fetchtingExternalAccount() {
      return this.$store.state.externalAccount.fetchtingExternalAccount
    },
  },
  created() {
    this.$store
      .dispatch('externalAccount/fetchAccount', this.$route.params.id)
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    updateAccount(account) {
      this.$store
        .dispatch('externalAccount/updateAccount', {
          id: this.$route.params.id,
          account: {
            endpoint: account.endpoint,
            label: account.label,
            bucketName: account.bucketName,
          },
        })
        .then(() => {
          this.$router.push({ name: 'external-accounts' })
        })
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
  },

}

</script>

<style scoped>
.input-username{
  cursor: not-allowed;
}
</style>
